import type { OwaDate, GlobalCalendarLocale } from "owa-datetime";
import { localizedFormatter } from "./localizedFormatter";

export function getUserTimeFormat(_dateFormat: string, timeFormat: string): string {
    return timeFormat;
}

const defaultExport: (date: OwaDate | null | undefined, locale?: GlobalCalendarLocale) => string = 
/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function localizedFormatter called at module scope is not allowed. This may cause unwanted side effects. */
localizedFormatter(getUserTimeFormat);
export default defaultExport;
